import * as React from 'react';

function SvgLinkedin(props) {
  return (
    <svg
      viewBox="-28 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      {...props}
    >
      <path
        d="M456.129 307.402v189.575c0 8.293-6.73 15.023-15.02 15.023h-85.504c-8.293 0-15.023-6.73-15.023-15.023V301.445c0-16.902-13.75-30.652-30.652-30.652-.993 0-1.965.047-2.938.137-15.531 1.484-27.73 14.601-27.73 30.515v195.532c0 8.293-6.719 15.023-15.02 15.023h-89.62c-9.231 0-16.755-7.52-16.755-16.766V168.383c0-9.242 7.524-16.766 16.754-16.766h87.887c9.246 0 16.754 7.524 16.754 16.766v7.101a113.269 113.269 0 0127.73-9.445 111.629 111.629 0 0120.223-2.21c26.969-.505 53.203 8.71 73.836 25.937 35 29.21 55.078 72.093 55.078 117.636zm0 0"
        fill="#2682ff"
      />
      <g fill="#6aa9ff">
        <path d="M121.906 169.164v325.29c0 9.675-7.87 17.546-17.547 17.546H18.047C8.37 512 .5 504.129.5 494.453V169.164c0-9.672 7.871-17.547 17.547-17.547h86.312c9.676 0 17.547 7.875 17.547 17.547zm0 0M122.406 61.2c0 33.745-27.46 61.198-61.207 61.198C27.461 122.398 0 94.945 0 61.2 0 27.45 27.46 0 61.2 0c33.745 0 61.206 27.45 61.206 61.2zm0 0" />
      </g>
    </svg>
  );
}

export default SvgLinkedin;
